import React, { createContext, useContext, useState, useCallback } from 'react';

const AdminAuthContext = createContext(null);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
const STORAGE_KEY = 'adminToken';

export const AdminAuthProvider = ({ children }) => {
  const [adminToken, setAdminToken] = useState(() => localStorage.getItem(STORAGE_KEY) || null);

  const login = useCallback(async (email, password) => {
    const res = await fetch(`${BACKEND_URL}/admin/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Login failed');
    localStorage.setItem(STORAGE_KEY, data.token);
    setAdminToken(data.token);
    return data.token;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    setAdminToken(null);
  }, []);

  return (
    <AdminAuthContext.Provider value={{ isAdmin: !!adminToken, adminToken, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
